import React from 'react';
import Box from '@material-ui/core/Box';
import { PDFViewer } from '@react-pdf/renderer';

import Invoice from '../../Test/Invoice';
import BolSignaturePanel from '../BolSignaturePanel/BolSignaturePanel';

const ViewJob = ({ invoice }) => {
  return (
    <Box style={{ width: '100%', maxWidth: 1040 }}>
      <BolSignaturePanel job={invoice} />
      <PDFViewer width='100%' height={960} className='app' style={{ border: '1px solid #e0e0e0' }}>
        <Invoice invoice={invoice} />
      </PDFViewer>
    </Box>
  );
};

export default ViewJob;
